import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { json } from '../api/apiClient';

export const CARD_PRINTS_PAGE_SIZE = 60;
// Längster Suchbegriff, den GET …/prints annimmt (Backend: config.CARD_PRINTS_MAX_QUERY_LENGTH);
// ein längerer ergibt 400.
export const CARD_PRINTS_MAX_QUERY_LENGTH = 100;

/**
 * Umschlag des Karten-Modals: GET /api/cards/oracle/:oracleId/detail?current=…. staleTime 5 Minuten —
 * Öffnen/Schließen derselben Karte lädt nicht neu; Aktionen invalidieren ['card-detail', oracleId].
 * Nach einem Print-Wechsel ändert sich `currentScryfallId` und damit der Schlüssel: bis der neue
 * Umschlag da ist, bleibt der alte stehen — aber nur für dieselbe Karte, sonst zeigte das Modal
 * kurz die Daten einer anderen Karte.
 */
export function useCardDetail(oracleId, currentScryfallId, enabled = true) {
  return useQuery({
    queryKey: ['card-detail', oracleId, currentScryfallId ?? null],
    queryFn: () => json(`/api/cards/oracle/${encodeURIComponent(oracleId)}/detail${currentScryfallId ? `?current=${encodeURIComponent(currentScryfallId)}` : ''}`),
    enabled: !!oracleId && enabled,
    staleTime: 1000 * 60 * 5,
    placeholderData: (previousData, previousQuery) => (previousQuery?.queryKey?.[1] === oracleId ? previousData : undefined),
  });
}

/**
 * Aktuelle Prints einer Karte, seitenweise (GET …/prints?offset&limit&q). Dieselbe Abfrage mit
 * leerem Suchbegriff speist das gekappte Raster und die Vollansicht. staleTime wie oben: sonst
 * lädt jedes erneute Öffnen alle schon geladenen Seiten nacheinander neu.
 */
export function useCardPrints(oracleId, query, enabled = true) {
  return useInfiniteQuery({
    queryKey: ['card-prints', oracleId, query],
    queryFn: ({ pageParam }) => json(
      `/api/cards/oracle/${encodeURIComponent(oracleId)}/prints?offset=${pageParam}&limit=${CARD_PRINTS_PAGE_SIZE}${query ? `&q=${encodeURIComponent(query)}` : ''}`,
    ),
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages) => {
      // Leere Seite trotz Restmenge: derselbe Offset käme endlos wieder
      if (!lastPage.items?.length) return undefined;
      const loaded = pages.reduce((n, p) => n + (p.items?.length ?? 0), 0);
      return loaded < lastPage.total ? loaded : undefined;
    },
    enabled: !!oracleId && enabled,
    staleTime: 1000 * 60 * 5,
  });
}
